import { BCBS } from "../constants/static";
export type UsaStatesUpperCase = "IL" | "MT" | "NM" | "OK" | "TX";
export type UsaStatesLowerCase = "il" | "mt" | "nm" | "ok" | "tx";

export const getStateCode = (subPath = BCBS): UsaStatesLowerCase | "" => {
  const domain = window.location.hostname;
  const parts = domain.split(".");
  const subdomain = parts.find(part => part.toLowerCase().startsWith(subPath));
  const subPathLength = subPath.length;
  const usaStates = ["IL", "MT", "NM", "OK", "TX"];

  if (subdomain && subdomain.length > subPathLength) {
    const state = subdomain.substring(subPathLength);
    if (usaStates.some(st => state.toUpperCase() === st)) {
      return state as UsaStatesLowerCase;
    }
  }
  return "";
};
